import { Yritysmuoto } from '@lemon/core-firebase/model/kayttaja'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { EmailLiite, VeroilmoitusEmailTextAutosaveData } from '../../_jaettu-lemonator/model/kirjanpito'

export interface LahetyksenLiitevalinnat {
  tuloslaskelma: boolean
  virallinenTuloslaskelma: boolean
  virallinenTase: boolean
  veroilmoitus: boolean
  taseErittely: boolean
}

export interface LahetyksenValinnat extends Pick<VeroilmoitusEmailTextAutosaveData, 'lahetysAvain' | 'piilokopioValittu' | 'tulosValittu' | 'virTulosValittu' | 'virTaseValittu' | 'veroilmoitusValittu'> {}

export interface SahkopostinTekstinOsat {
  alku: string
  paateksti: string | null
  sisallytaPaateksti: boolean
  tili9940Teksti: string | null
  sisallytaTili9940Teksti: boolean
  loppu: string
}

const RAPORTIN_ARVIOITU_KOKO = 100 * 1000
const LIITTEEN_OLETUSKOKO = 512 * 1000
const LIITTEIDEN_ENIMMAISKOKO = Math.pow(10, 7)

/** Sähköpostin liitteiden arvioitu kokonaiskoko megatavuina, jos se ylittää 10 MT:n rajan; muuten 0. */
export function laskeLiitteidenKokoJosLiianSuuri(valinnat: LahetyksenLiitevalinnat, liitteet: EmailLiite[], currencyService: CurrencyService): number {
  let kokonaiskoko = 0
  for (const valittu of [valinnat.tuloslaskelma, valinnat.virallinenTuloslaskelma, valinnat.virallinenTase, valinnat.veroilmoitus, valinnat.taseErittely]) {
    if (valittu) {
      kokonaiskoko += RAPORTIN_ARVIOITU_KOKO
    }
  }
  for (const liite of liitteet || []) {
    kokonaiskoko += liite.koko || LIITTEEN_OLETUSKOKO
  }
  if (kokonaiskoko > LIITTEIDEN_ENIMMAISKOKO) {
    return currencyService.roundHalfUp(kokonaiskoko / Math.pow(10, 6), 1)
  }
  return 0
}

/** Liitevalinnat luonnoksesta tai, jos niitä ei ole tallennettu, asiakastyypin ja yritysmuodon oletukset. */
export function annaLahetyksenValinnat(tallennettu: Partial<VeroilmoitusEmailTextAutosaveData> | null, yritysmuoto: Yritysmuoto, asiakastyyppi: 'holvi' | 'regular'): Partial<LahetyksenValinnat> {
  const onkoTallennettu = (arvo: boolean | undefined) => arvo === true || arvo === false
  return {
    lahetysAvain: tallennettu?.lahetysAvain,
    piilokopioValittu: asiakastyyppi === 'holvi' ? false : (tallennettu?.piilokopioValittu ?? true),
    tulosValittu: onkoTallennettu(tallennettu?.tulosValittu) ? tallennettu.tulosValittu : yritysmuoto !== Yritysmuoto.OSAKEYHTIO,
    virTulosValittu: onkoTallennettu(tallennettu?.virTulosValittu) ? tallennettu.virTulosValittu : yritysmuoto !== Yritysmuoto.OSAKEYHTIO,
    virTaseValittu: onkoTallennettu(tallennettu?.virTaseValittu) ? tallennettu.virTaseValittu : asiakastyyppi !== 'holvi' && yritysmuoto !== Yritysmuoto.OSAKEYHTIO,
    veroilmoitusValittu: onkoTallennettu(tallennettu?.veroilmoitusValittu) ? tallennettu.veroilmoitusValittu : asiakastyyppi !== 'holvi',
  }
}

/** Kokoaa sähköpostin tekstin: alku, valitut automaattitekstit ja loppu tyhjällä rivillä erotettuina. */
export function yhdistaSahkopostinTeksti(osat: SahkopostinTekstinOsat): string {
  let teksti = osat.alku || ''
  if (osat.sisallytaPaateksti) {
    teksti = teksti.trimEnd() + '\n\n' + (osat.paateksti || '')
  }
  if (osat.sisallytaTili9940Teksti) {
    teksti = teksti.trimEnd() + '\n\n' + (osat.tili9940Teksti || '')
  }
  return teksti.trimEnd() + '\n\n' + (osat.loppu || '').trimStart()
}
